import { RootSelector, getStore } from '../../reducers';
import { PackShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { Asset } from '../../api';
import { Loading } from '../finder/model';

export const getPack: RootSelector<PackShape> = createSelector(getStore, (state) => state.pack);

export const getData: RootSelector<PackShape['data']> = createSelector(
  [getPack],
  (pack) => pack.data,
);

export const getAssetsInPack: RootSelector<Partial<Record<Asset['id'], boolean>>> = createSelector(
  getData,
  (data) => {
    const result: Partial<Record<Asset['id'], boolean>> = {};
    data.asset_ids.forEach((id) => {
      result[id] = true;
    });
    return result;
  },
);

export const getAssetsById: RootSelector<Partial<Record<Asset['id'], Asset>>> = createSelector(
  getData,
  (data) => {
    const result: Partial<Record<Asset['id'], Asset>> = {};
    data.assets.forEach((asset) => {
      result[asset.id] = asset;
    });
    return result;
  },
);

export const getLoading: RootSelector<Loading> = createSelector(getPack, (pack) => pack.loading);

export const getHasNextPage: RootSelector<boolean> = createSelector(
  getPack,
  (pack) => pack.hasNextPage,
);

export const getScrollHash: RootSelector<string> = createSelector(
  getPack,
  (pack) => pack.scrollHash,
);

export const getInProgress: RootSelector<Partial<Record<Asset['id'], true>>> = createSelector(
  getPack,
  (pack) => pack.inProgress,
);

export const getAllInProgress: RootSelector<PackShape['allInProgress']> = createSelector(
  getPack,
  (pack) => pack.allInProgress,
);

export const getRelatedSharing = createSelector(getPack, (pack) => pack.relatedSharing);

export const getRelatedSharingInProgress = createSelector(
  getPack,
  (pack) => pack.relatedSharingInProgress,
);
